import React, { useEffect } from 'react';

const ConditionsUtilisation: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Conditions Générales d'Utilisation
        </h1>
        <p className="text-sm text-gray-500 mb-10">En vigueur au 31 mars 2026</p>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-3">1. Objet</h2>
          <p className="text-gray-700 leading-relaxed">
            Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») ont pour objet de
            définir les modalités et conditions dans lesquelles SOS IT Services met à disposition ses
            services via le site <span className="font-medium">sos-it-services.com</span>, ainsi que
            les droits et obligations des utilisateurs dans ce cadre.
          </p>
          <p className="mt-3 text-gray-700 leading-relaxed">
            Toute utilisation du site implique l'acceptation pleine et entière des présentes CGU.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-3">2. Accès au service</h2>
          <p className="text-gray-700 leading-relaxed">
            Le site est accessible gratuitement à tout utilisateur disposant d'un accès à Internet.
            Tous les frais supportés par l'utilisateur pour accéder au service (matériel
            informatique, logiciels, connexion Internet, etc.) sont à sa charge.
          </p>
          <p className="mt-3 text-gray-700 leading-relaxed">
            SOS IT Services se réserve le droit de suspendre ou d'interrompre l'accès au site, sans
            préavis, notamment pour des raisons de maintenance ou de mise à jour.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-3">
            3. Création de compte et responsabilités utilisateur
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Certaines fonctionnalités du site nécessitent la création d'un compte personnel.
            L'utilisateur s'engage à :
          </p>
          <ul className="mt-3 list-disc list-inside space-y-1 text-gray-700">
            <li>Fournir des informations exactes, complètes et à jour lors de son inscription</li>
            <li>Maintenir la confidentialité de ses identifiants de connexion</li>
            <li>
              Notifier immédiatement SOS IT Services de toute utilisation non autorisée de son
              compte
            </li>
            <li>
              Ne pas créer de compte au nom d'une autre personne sans son autorisation expresse
            </li>
          </ul>
          <p className="mt-3 text-gray-700 leading-relaxed">
            SOS IT Services ne pourra être tenu responsable de toute perte ou dommage résultant du
            non-respect de ces obligations par l'utilisateur.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-3">4. Services proposés</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            SOS IT Services propose les prestations suivantes :
          </p>
          <ul className="mt-3 list-disc list-inside space-y-1 text-gray-700">
            <li>
              <span className="font-medium">Dépannage informatique</span> : intervention à distance
              ou à domicile (dans un rayon de 50 km autour de Genève) pour la résolution de pannes,
              l'installation de logiciels, la maintenance et le conseil
            </li>
            <li>
              <span className="font-medium">Création de sites web</span> : conception,
              développement et mise en ligne de sites vitrines et d'applications web sur mesure
            </li>
          </ul>
          <p className="mt-3 text-gray-700 leading-relaxed">
            Les caractéristiques détaillées de chaque prestation sont précisées sur les pages
            dédiées du site et dans les devis établis avant toute intervention.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-3">5. Tarifs et paiements</h2>
          <p className="text-gray-700 leading-relaxed">
            Les tarifs des prestations sont indiqués en euros toutes taxes comprises (TTC) sur le
            site. Ils sont susceptibles d'être modifiés à tout moment ; les prestations sont
            facturées sur la base des tarifs en vigueur au moment de la commande.
          </p>
          <p className="mt-3 text-gray-700 leading-relaxed">
            Les paiements en ligne sont traités de manière sécurisée par{' '}
            <span className="font-medium">Stripe</span>. SOS IT Services ne conserve aucune donnée
            bancaire sur ses propres serveurs. Une facture est émise pour chaque prestation réalisée.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-3">6. Obligations de l'utilisateur</h2>
          <p className="text-gray-700 leading-relaxed">
            L'utilisateur s'engage à utiliser le site et les services de SOS IT Services de manière
            conforme à la législation en vigueur et aux présentes CGU. Il est notamment interdit de :
          </p>
          <ul className="mt-3 list-disc list-inside space-y-1 text-gray-700">
            <li>
              Utiliser le site à des fins illicites, frauduleuses ou contraires aux bonnes mœurs
            </li>
            <li>
              Porter atteinte aux droits de propriété intellectuelle de SOS IT Services ou de tiers
            </li>
            <li>Tenter d'accéder sans autorisation aux systèmes informatiques de SOS IT Services</li>
            <li>Diffuser des contenus diffamatoires, abusifs ou dégradants via le service</li>
            <li>Perturber le fonctionnement du site par tout moyen technique</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-3">
            7. Responsabilité de SOS IT Services
          </h2>
          <p className="text-gray-700 leading-relaxed">
            SOS IT Services s'engage à mettre en œuvre tous les moyens nécessaires pour assurer
            l'accès au site et la qualité des prestations proposées. Toutefois, sa responsabilité ne
            saurait être engagée en cas de :
          </p>
          <ul className="mt-3 list-disc list-inside space-y-1 text-gray-700">
            <li>Interruption du service pour cause de maintenance ou de force majeure</li>
            <li>
              Dommages indirects résultant de l'utilisation ou de l'impossibilité d'utiliser le site
            </li>
            <li>
              Perte de données imputable à un tiers ou à une défaillance matérielle de l'utilisateur
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-3">8. Propriété intellectuelle</h2>
          <p className="text-gray-700 leading-relaxed">
            L'ensemble des contenus présents sur le site (textes, images, logos, code source, etc.)
            est protégé par le droit de la propriété intellectuelle et appartient à SOS IT Services
            ou à ses partenaires. Toute reproduction ou utilisation non autorisée est strictement
            interdite.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-3">9. Résiliation</h2>
          <p className="text-gray-700 leading-relaxed">
            SOS IT Services se réserve le droit de suspendre ou de supprimer le compte d'un
            utilisateur, sans préavis ni indemnité, en cas de violation des présentes CGU ou de
            comportement préjudiciable pour le service ou les autres utilisateurs.
          </p>
          <p className="mt-3 text-gray-700 leading-relaxed">
            L'utilisateur peut demander la suppression de son compte à tout moment en contactant{' '}
            <a href="mailto:contact@sos-it-services.com" className="text-blue-600 hover:underline">
              contact@sos-it-services.com
            </a>
            .
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-3">10. Droit applicable</h2>
          <p className="text-gray-700 leading-relaxed">
            Les présentes CGU sont soumises au droit français. Tout litige relatif à leur
            interprétation ou à leur exécution relèvera de la compétence exclusive des juridictions
            françaises, sauf disposition légale contraire.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ConditionsUtilisation;
